module.exports = __webpack_public_path__ + "static/img/led_difuso_vermelho_5mm-1.46d6e05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_difuso_vermelho_5mm-1.svg
// module id = 6f1k
// module chunks = 0